module.exports = __webpack_public_path__ + "82ccdac9bc8fc5f86982412a063103bc.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/wall_items/window-snowy-mountains.png
// module id = 1647
// module chunks = 0